export default __webpack_public_path__ + "static/Wamo_mobile-73e9ccd35181468cbe3bfdf73e502bc6.jpg";